/**
 * Исключение ActionError
 * Выбрасывается, когда в ответе от сервера присутствуют поля code и developerMessage
 * (ошибки middle-server)
 *
 * Подробности в console — в useErrorHandler (DEV); не логировать в конструкторе.
 */
export class ActionError extends Error {
  public readonly code: string | number
  public readonly developerMessage: string
  public readonly type?: string
  public readonly url?: string

  constructor(
    code: string | number,
    developerMessage: string,
    message?: string,
    extras?: { type?: string; url?: string },
  ) {
    super(message || developerMessage || 'Action error occurred')

    this.name = 'ActionError'
    this.code = code
    this.developerMessage = developerMessage
    this.type = extras?.type
    this.url = extras?.url

    Object.setPrototypeOf(this, ActionError.prototype)
  }
}
